import { Pipe, PipeTransform } from '@angular/core';
import { isString } from '@k2/common/helpers';
import { UrlGenerator } from '@k2/common/file-jet/url-generator.service';

@Pipe({
    name: 'url',
    standalone: false
})
export class UrlPipe implements PipeTransform {
  constructor(private urlGenerator: UrlGenerator) {}

  transform(file: any, mutation?: string): string {
    const fileObj = normalize(file);
    if (!fileObj || !fileObj.identifier) return;

    return this.urlGenerator.generateUrl(fileObj, mutation);
  }
}

function normalize(file: any) {
  if (isString(file)) return { identifier: file };
  return file;
}
